import { createApi } from '@reduxjs/toolkit/query/react'
import {
  FetchUsersResponse,
  StandardFetchRequestPayload,
  UserInvitationPayload,
  UserListItem,
  ChangeRolePayload,
} from '@api/admPortal/models'
import { serializeURLParams } from '@utils/basic'
import { getBaseQuery } from '@api/admPortal/baseQuery'

// CONTRUCT ENDPOINTS AND API CALL HOOKS
export const userManagementAPI = createApi({
  reducerPath: 'userManagementAPI',
  baseQuery: getBaseQuery('UserManagement'),
  tagTypes: ['user', 'role', 'app'],
  endpoints: builder => ({
    FetchUsers: builder.query<FetchUsersResponse, StandardFetchRequestPayload>({
      query: ({ pageNumber, itemsPerPage, filter, userName }) =>
        `FetchUsers?${serializeURLParams({
          pageNumber,
          itemsPerPage,
          filter,
          userName: userName,
        })}`,
      providesTags: ['user'],
    }),
    InviteUser: builder.mutation<void, UserInvitationPayload>({
      query: invite => ({
        url: 'InviteUser',
        method: 'POST',
        body: invite,
      }),
      invalidatesTags: ['user'],
    }),
    ChangeRole: builder.mutation<void, ChangeRolePayload>({
      query: payload => ({
        url: 'ChangeRole',
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['role', 'user'],
    }),
    DeleteUser: builder.mutation<void, string>({
      query: userId => ({
        url: `DeleteUser/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['user'],
    }),
    DisableUser: builder.mutation<void, UserListItem>({
      query: payload => ({
        url: `DisableUser`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['user'],
    }),
    EnableUser: builder.mutation<void, UserListItem>({
      query: payload => ({
        url: `EnableUser`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['user'],
    }),
    SendResetPasswordEmail: builder.mutation<void, void>({
      query: () => `SendResetPasswordEmail`,
    }),
  }),
})
// Export the auto-generated hooks from the endpoints constructed in createApi
export const {
  useInviteUserMutation,
  useFetchUsersQuery,
  useChangeRoleMutation,
  useDeleteUserMutation,
  useDisableUserMutation,
  useEnableUserMutation,
  useSendResetPasswordEmailMutation,
} = userManagementAPI
